/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SettlementDetailAcceptanceCommentModel} from '../../services/settlement-detail-configuration/models/settlement-detail-acceptance-comment.model';


@Component({
    selector: 'app-settlement-accept-comment',
    templateUrl: './settlement-accept-comment.component.html',
    styleUrls: ['./settlement-accept-comment.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettlementAcceptCommentComponent {
    @Input() acceptanceComment?: SettlementDetailAcceptanceCommentModel;

    readonly LABEL_COMMENT = 'Acceptance comment';
    readonly LABEL_ACCEPTED = 'Accepted by';
}
